import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Trigger from '@mtfe/rc-trigger';
import dayjs from 'dayjs';
import { polyfill } from 'react-lifecycles-compat';
import createRef from '@roo/create-react-ref/createRef';
import locale from '../locale';
import { isFunction, isArray } from '@utiljs/is';
import classNames from 'classnames';
import warning from 'warning';
import Icon from '../Icon';
import IconClear from './IconClear';
import { PANEL_LIST, END_PANEL_LIST } from './const';
import { getTimeValue, togglePanel, onOpenChange, dateFormatter } from './utils';
import { getPlacements } from './placements';
import Input from '../Input';
import DatePanel from './DatePanel';
import MonthPanel from './MonthPanel';
import YearPanel from './YearPanel';
import TimeSelect from './TimePicker';
import '@mtfe/rc-trigger/assets/index.css';

var RangePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(RangePicker, _React$Component);

  var _super = _createSuper(RangePicker);

  function RangePicker(props) {
    var _this;

    _classCallCheck(this, RangePicker);

    _this = _super.call(this, props);
    _this.rootNode = createRef();
    _this.inputNode = createRef();

    _this.onOpenChange = function () {};

    _this.fold = false;
    /**
     * 受控模式判断
     * @param value any
     */

    _this.isControlled = function (value) {
      return _Array$isArray(value);
    };

    _this.handlePropsChange = function (arg) {
      var onChange = _this.props.onChange;

      if (isFunction(onChange)) {
        onChange(arg);
      } else {
        warning(false, 'RangePicker: onChange 类型应该是函数');
      }
    };

    _this.selectDate = function (timestamp) {
      var _this$state = _this.state,
          selectEndDate = _this$state.selectEndDate,
          selectDate = _this$state.selectDate;
      var _this$props = _this.props,
          format = _this$props.format,
          valueOfType = _this$props.valueOfType;
      var nextSelectDate = null;
      var nextSelectEndDate = null; // 需要默认的 selectEndDate， 所以没有选择结束日期时，结束日期与开始日期是同一个值。

      if (!selectEndDate) {
        nextSelectEndDate = dayjs(timestamp);
        nextSelectDate = selectDate;
      } else {
        nextSelectDate = dayjs(timestamp);
      } // 开始和结束时间比较，对调。


      if (nextSelectDate && nextSelectEndDate && nextSelectDate.valueOf() > nextSelectEndDate.valueOf()) {
        var _ref = [nextSelectEndDate, nextSelectDate];
        nextSelectDate = _ref[0];
        nextSelectEndDate = _ref[1];
      } // 获取当前的时分秒


      var currentSelectDate = nextSelectDate.set('hour', selectDate.hour()).set('minute', selectDate.minute()).set('second', selectDate.second());

      _this.setState({
        // startValue: currentSelectDate,
        // endValue: (nextSelectEndDate && nextSelectEndDate.set('hour', nextSelectEndDate.hour()).set('minute', nextSelectEndDate.minute()).set('second', nextSelectEndDate.second())) || '',
        startDate: nextSelectDate,
        selectDate: currentSelectDate,
        selectEndDate: nextSelectEndDate && nextSelectEndDate.set('hour', nextSelectEndDate.hour()).set('minute', nextSelectEndDate.minute()).set('second', nextSelectEndDate.second()) || null
      }, function () {
        var _assertThisInitialize = _assertThisInitialized(_this),
            state = _assertThisInitialize.state;

        if (state.selectEndDate) {
          _this.setState({
            open: false
          });
        }
      });

      var sd = getTimeValue(valueOfType, currentSelectDate, format);
      var ed = getTimeValue(valueOfType, nextSelectEndDate, format);

      if (ed) {
        if (_this.isControlled(_this.props.value)) {
          _this.handlePropsChange([sd, ed]);
        } else {
          _this.setState({
            startValue: currentSelectDate,
            endValue: nextSelectEndDate && nextSelectEndDate.set('hour', nextSelectEndDate.hour()).set('minute', nextSelectEndDate.minute()).set('second', nextSelectEndDate.second()) || ''
          }, function () {
            _this.handlePropsChange([sd, ed]);
          });
        }
      }
    };

    _this.selectEndDate = function (timestamp) {
      var _this$state2 = _this.state,
          selectEndDate = _this$state2.selectEndDate,
          selectDate = _this$state2.selectDate;
      var _this$props2 = _this.props,
          format = _this$props2.format,
          valueOfType = _this$props2.valueOfType;
      var nextSelectDate = dayjs();
      var nextSelectEndDate = null;

      if (!selectEndDate) {
        nextSelectEndDate = dayjs(timestamp);
        nextSelectDate = selectDate;
      } else {
        nextSelectDate = dayjs(timestamp);
      }

      if (nextSelectDate && nextSelectEndDate && nextSelectDate.valueOf() > nextSelectEndDate.valueOf()) {
        var _ref2 = [nextSelectEndDate, nextSelectDate];
        nextSelectDate = _ref2[0];
        nextSelectEndDate = _ref2[1];
      }

      var currentSelectDate = nextSelectEndDate && nextSelectEndDate.set('hour', nextSelectEndDate.hour()).set('minute', nextSelectEndDate.minute()).set('second', nextSelectEndDate.second());

      _this.setState({
        // startValue: nextSelectDate.set('hour', selectDate.hour()).set('minute', selectDate.minute()).set('second', selectDate.second()),
        // endValue: currentSelectDate,
        startDate: nextSelectDate,
        selectDate: nextSelectDate.set('hour', selectDate.hour()).set('minute', selectDate.minute()).set('second', selectDate.second()),
        endDate: nextSelectDate.set('month', nextSelectDate.month() + 1),
        selectEndDate: currentSelectDate
      }, function () {
        var _assertThisInitialize2 = _assertThisInitialized(_this),
            state = _assertThisInitialize2.state;

        if (state.selectEndDate) {
          _this.setState({
            open: false
          });
        }
      });

      var sd = getTimeValue(valueOfType, nextSelectDate, format);
      var ed = getTimeValue(valueOfType, currentSelectDate, format);

      if (ed) {
        if (_this.isControlled(_this.props.value)) {
          _this.handlePropsChange([sd, ed]);
        } else {
          _this.setState({
            startValue: nextSelectDate.set('hour', selectDate.hour()).set('minute', selectDate.minute()).set('second', selectDate.second()),
            endValue: currentSelectDate
          }, function () {
            _this.handlePropsChange([sd, ed]);
          });
        }
      }
    };

    _this.selectMonthOrYear = function (timestamp, type) {
      var tl = togglePanel(PANEL_LIST, "".concat(type, "Show"));

      _this.setState(_Object$assign({
        startDate: dayjs(timestamp)
      }, tl));
    };

    _this.selectEndMonthOrYear = function (timestamp, type) {
      var tl = togglePanel(END_PANEL_LIST, "end".concat(type, "Show"));

      _this.setState(_Object$assign({
        endDate: dayjs(timestamp)
      }, tl));
    };

    _this.selectTime = function (time, type) {
      var selectDate = _this.state.selectDate;
      var _this$props3 = _this.props,
          valueOfType = _this$props3.valueOfType,
          format = _this$props3.format;

      _this.setState({
        selectDate: selectDate.set(type, time)
      }, function () {
        var _assertThisInitialize3 = _assertThisInitialized(_this),
            state = _assertThisInitialize3.state;

        var sd = getTimeValue(valueOfType, selectDate.set(type, time), format);
        var ed = getTimeValue(valueOfType, state.selectEndDate, format);

        _this.handlePropsChange([sd, ed]);
      });
    };

    _this.selectEndTime = function (time, type) {
      var selectEndDate = _this.state.selectEndDate;
      var _this$props4 = _this.props,
          valueOfType = _this$props4.valueOfType,
          format = _this$props4.format;

      _this.setState({
        selectEndDate: selectEndDate.set(type, time)
      }, function () {
        var _assertThisInitialize4 = _assertThisInitialized(_this),
            state = _assertThisInitialize4.state;

        var sd = getTimeValue(valueOfType, state.selectDate, format);
        var ed = getTimeValue(valueOfType, selectEndDate.set(type, time), format);

        _this.handlePropsChange([sd, ed]);
      });
    };

    _this.handleChangeDate = function (type, unitType, count) {
      var _this$state3 = _this.state,
          startDate = _this$state3.startDate,
          endDate = _this$state3.endDate;
      count = count || 1;
      var calcuDate = dayjs();
      calcuDate = type === 'add' ? startDate.add(count, unitType) : startDate.subtract(count, unitType);
      var newEndDate = endDate;

      if (calcuDate.year() > endDate.year()) {
        newEndDate = newEndDate.set('year', calcuDate.year());
      } else if (calcuDate.year() === endDate.year() && calcuDate.month() === endDate.month()) {
        newEndDate = newEndDate.set('month', calcuDate.month() + 1);
      }

      _this.setState({
        startDate: calcuDate,
        endDate: newEndDate
      });
    };

    _this.handleChangeEndDate = function (type, unitType, count) {
      var _this$state4 = _this.state,
          endDate = _this$state4.endDate,
          startDate = _this$state4.startDate;
      count = count || 1;
      var calcuDate = dayjs();
      calcuDate = type === 'add' ? endDate.add(count, unitType) : endDate.subtract(count, unitType);
      var newStartDate = startDate;

      if (calcuDate.year() < startDate.year()) {
        newStartDate = newStartDate.set('year', calcuDate.year());
      } else if (calcuDate.year() === startDate.year() && calcuDate.month() === startDate.month()) {
        newStartDate = newStartDate.set('month', calcuDate.month() - 1);
      }

      _this.setState({
        endDate: calcuDate,
        startDate: newStartDate
      });
    };

    _this.showPanel = function (type) {
      var tl = togglePanel(PANEL_LIST, "".concat(type, "Show"));

      _this.setState(_Object$assign({}, tl));
    };

    _this.showEndPanel = function (type) {
      var tl = togglePanel(END_PANEL_LIST, "end".concat(type, "Show"));

      _this.setState(_Object$assign({}, tl));
    };

    _this.clearTime = function (evt) {
      evt.stopPropagation();

      if (_Array$isArray(_this.props.value)) {
        _this.handlePropsChange([]);
      } else {
        _this.setState({
          startValue: '',
          endValue: '',
          selectDate: dayjs(),
          selectEndDate: dayjs(),
          hoverDate: '',
          startDate: dayjs(),
          endDate: dayjs().add(1, 'month')
        }, function () {
          _this.handlePropsChange([]);
        });
      }
    };

    _this.inputFocus = function (e) {
      var onFocus = _this.props.onFocus;

      if (isFunction(onFocus)) {
        onFocus(e);
      }
    };

    _this.inputBlur = function (e) {
      var onBlur = _this.props.onBlur;

      if (isFunction(onBlur)) {
        onBlur(e);
      }
    };

    _this.hoverDate = function (timestamp, evt) {
      var _this$state5 = _this.state,
          selectDate = _this$state5.selectDate,
          selectEndDate = _this$state5.selectEndDate;

      if (selectDate && selectEndDate) {
        return;
      }

      evt.stopPropagation();

      _this.setState({
        hoverDate: dayjs(timestamp)
      });
    };

    var _this$props5 = _this.props,
        value = _this$props5.value,
        defaultValue = _this$props5.defaultValue,
        valueOfType = _this$props5.valueOfType,
        open = _this$props5.open;

    if (value !== undefined && value !== null && !_Array$isArray(value)) {
      console.warn('RangePicker: value 类型应该是数组', value);
    }

    if (defaultValue !== undefined && defaultValue !== null && !_Array$isArray(defaultValue)) {
      console.warn('RangePicker: defaultValue 类型应该是数组', defaultValue);
    } // eslint-disable-next-line


    var valueArray = _Array$isArray(value) ? value : _Array$isArray(defaultValue) ? defaultValue : ['', ''];
    var startValue = dateFormatter(valueArray[0], valueOfType);
    var endValue = dateFormatter(valueArray[1], valueOfType);
    var firstDate = startValue || dayjs();
    var secondDate = endValue || dayjs().add(1, 'month');
    var selectDate = startValue || endValue || dayjs();
    var selectEndDate = endValue || startValue || dayjs(); // 同月判断

    if (startValue && endValue) {
      if (startValue.year() === endValue.year() && startValue.month() === endValue.month()) {
        secondDate = startValue.add(1, 'month');
      }
    } else {
      if (startValue) {
        secondDate = startValue.add(1, 'month');
      } else if (endValue) {
        firstDate = endValue.subtract(1, 'month');
      }
    }

    _this.state = {
      startValue: startValue,
      // eslint-disable-next-line
      startInitValue: dateFormatter(valueArray[0], valueOfType, true),
      endValue: endValue,
      // eslint-disable-next-line
      endInitValue: dateFormatter(valueArray[1], valueOfType, true),
      startDate: firstDate,
      selectDate: selectDate,
      endDate: secondDate,
      selectEndDate: selectEndDate,
      dateShow: true,
      monthShow: false,
      yearShow: false,
      // eslint-disable-next-line
      cacheValue: value,
      hoverDate: startValue || dayjs(),
      enddateShow: true,
      endmonthShow: false,
      endyearShow: false,
      open: open
    };
    return _this;
  }

  _createClass(RangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onOpenChange = onOpenChange.bind(this);
      window.addEventListener('click', this.onOpenChange);
    }
    /**
     * TODO: getDerivedStateFromProps 只用于受控模式下的状态更新，其他情况不处理。
     * 1. 受控模式： 防止 selectMonthOrYear 引起更新
     * 2. 受控定义： 只要是数组，不管是空的还是非空，都判定为受控模式。
     * @param nextProps
     * @param state
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.onOpenChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state6 = this.state,
          open = _this$state6.open,
          selectEndDate = _this$state6.selectEndDate,
          startValue = _this$state6.startValue,
          endValue = _this$state6.endValue;
      var endDate = endValue; // const { startDateCache, endDateCache } = this;

      if (!open && !selectEndDate && startValue && endValue) {
        if (startValue && endValue && startValue.year() === endValue.year() && startValue.month() === endValue.month()) {
          endDate = endValue.add(1, 'month');
        }
        /* eslint-disable*/


        this.setState({
          startDate: startValue,
          selectDate: startValue,
          hoverDate: endValue,
          endDate: endDate,
          selectEndDate: endValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state7 = this.state,
          startValue = _this$state7.startValue,
          endValue = _this$state7.endValue,
          startDate = _this$state7.startDate,
          selectDate = _this$state7.selectDate,
          endDate = _this$state7.endDate,
          selectEndDate = _this$state7.selectEndDate,
          dateShow = _this$state7.dateShow,
          monthShow = _this$state7.monthShow,
          yearShow = _this$state7.yearShow,
          enddateShow = _this$state7.enddateShow,
          endmonthShow = _this$state7.endmonthShow,
          endyearShow = _this$state7.endyearShow,
          open = _this$state7.open,
          hoverDate = _this$state7.hoverDate;
      var _this$props6 = this.props,
          showTime = _this$props6.showTime,
          placeholder = _this$props6.placeholder,
          disabledDate = _this$props6.disabledDate,
          format = _this$props6.format,
          disabled = _this$props6.disabled,
          popupContainer = _this$props6.popupContainer,
          className = _this$props6.className,
          clearable = _this$props6.clearable,
          dateCellRender = _this$props6.dateCellRender,
          inputClassName = _this$props6.inputClassName,
          size = _this$props6.size,
          flip = _this$props6.flip,
          disabledTime = _this$props6.disabledTime,
          placement = _this$props6.placement;
      return /*#__PURE__*/React.createElement(Trigger, {
        builtinPlacements: getPlacements(flip),
        popupPlacement: placement,
        getPopupContainer: isFunction(popupContainer) ? popupContainer : function () {
          return popupContainer;
        },
        popupVisible: disabled ? false : open,
        action: ['click'],
        popup: /*#__PURE__*/React.createElement("div", {
          className: "roo-datepicker roo-datepicker-ranger ".concat(className),
          ref: this.rootNode
        }, /*#__PURE__*/React.createElement("div", {
          className: "roo-datepicker-data-panel datepicker-days",
          key: "start".concat(selectDate ? selectDate.format('YYYYMMDD') : 0).concat(selectEndDate ? selectEndDate.format('YYYYMMDD') : 0).concat(hoverDate && hoverDate.millisecond())
        }, showTime ? /*#__PURE__*/React.createElement("div", {
          className: "roo-datepicker-inputs"
        }, /*#__PURE__*/React.createElement(Input, {
          key: "".concat(startDate.date()).concat(startDate.month()).concat(startDate.year()),
          type: "text",
          className: "roo-input roo-input-inline roo-input-xs",
          value: selectDate && selectDate.format('YYYY-MM-DD')
        }), /*#__PURE__*/React.createElement(Trigger, {
          builtinPlacements: getPlacements(flip),
          popupPlacement: "bottomLeft",
          action: ['click'],
          popupStyle: {
            whiteSpace: 'nowrap'
          },
          popup: /*#__PURE__*/React.createElement(TimeSelect, {
            disabledTime: disabledTime,
            value: selectDate,
            defaultValue: selectDate,
            onChange: this.selectTime
          })
        }, /*#__PURE__*/React.createElement(Input, {
          key: "".concat(selectDate.format('HH:mm:ss')),
          type: "text",
          className: "roo-input roo-input-inline roo-input-xs",
          value: selectDate.format('HH:mm:ss')
        }))) : null, /*#__PURE__*/React.createElement(YearPanel, {
          show: yearShow,
          startDate: startDate,
          selectDate: selectDate,
          onSelectYear: this.selectMonthOrYear,
          handleChangeDate: this.handleChangeDate,
          disabledDate: disabledDate,
          dateCellRender: dateCellRender
        }), /*#__PURE__*/React.createElement(MonthPanel, {
          show: monthShow,
          startDate: startDate,
          selectDate: selectDate,
          onShowPanel: this.showPanel,
          onSelectMonth: this.selectMonthOrYear,
          handleChangeDate: this.handleChangeDate,
          disabledDate: disabledDate,
          dateCellRender: dateCellRender
        }), /*#__PURE__*/React.createElement(DatePanel, {
          show: dateShow,
          startDate: startDate,
          hoverDate: hoverDate,
          selectDate: [selectDate, selectEndDate],
          onShowPanel: this.showPanel,
          onSelectDate: this.selectDate,
          handleChangeDate: this.handleChangeDate,
          onHover: this.hoverDate,
          disabledDate: disabledDate,
          dateCellRender: dateCellRender
        })), /*#__PURE__*/React.createElement("div", {
          className: "roo-datepicker-data-panel datepicker-days",
          key: "end".concat(selectDate ? selectDate.format('YYYYMMDD') : 0).concat(selectEndDate ? selectEndDate.format('YYYYMMDD') : 0).concat(hoverDate && hoverDate.millisecond())
        }, showTime ? /*#__PURE__*/React.createElement("div", {
          className: "roo-datepicker-inputs"
        }, /*#__PURE__*/React.createElement(Input, {
          key: "".concat(startDate.date()).concat(startDate.month()).concat(startDate.year()),
          type: "text",
          className: "roo-input roo-input-inline roo-input-xs",
          value: selectEndDate && selectEndDate.format('YYYY-MM-DD') || ''
        }), /*#__PURE__*/React.createElement(Trigger, {
          builtinPlacements: getPlacements(flip),
          popupPlacement: "bottomLeft",
          action: ['click'],
          popupStyle: {
            whiteSpace: 'nowrap'
          },
          popup: /*#__PURE__*/React.createElement(TimeSelect, {
            disabledTime: disabledTime,
            value: selectEndDate || endDate,
            defaultValue: selectEndDate || endDate,
            onChange: this.selectEndTime
          })
        }, /*#__PURE__*/React.createElement(Input, {
          key: "".concat(selectEndDate && selectEndDate.format('HH:mm:ss')) || '',
          type: "text",
          className: "roo-input roo-input-inline roo-input-xs",
          value: selectEndDate && selectEndDate.format('HH:mm:ss') || ''
        }))) : null, /*#__PURE__*/React.createElement(YearPanel, {
          show: endyearShow,
          startDate: endDate,
          selectDate: selectEndDate || selectDate,
          onSelectYear: this.selectEndMonthOrYear,
          handleChangeDate: this.handleChangeEndDate,
          disabledDate: disabledDate,
          dateCellRender: dateCellRender
        }), /*#__PURE__*/React.createElement(MonthPanel, {
          show: endmonthShow,
          startDate: endDate,
          selectDate: selectEndDate || selectDate,
          onShowPanel: this.showEndPanel,
          onSelectMonth: this.selectEndMonthOrYear,
          handleChangeDate: this.handleChangeEndDate,
          disabledDate: disabledDate,
          dateCellRender: dateCellRender
        }), /*#__PURE__*/React.createElement(DatePanel, {
          show: enddateShow,
          startDate: endDate,
          hoverDate: hoverDate,
          selectDate: [selectDate, selectEndDate],
          onShowPanel: this.showEndPanel,
          onSelectDate: this.selectEndDate,
          handleChangeDate: this.handleChangeEndDate,
          onHover: this.hoverDate,
          disabledDate: disabledDate,
          dateCellRender: dateCellRender
        })))
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-input-group roo-input-group-outline has-icon', disabled && 'roo-input-group-disabled'),
        ref: this.inputNode
      }, /*#__PURE__*/React.createElement(Input, {
        size: size,
        className: classNames('roo-input', inputClassName),
        disabled: disabled,
        placeholder: isArray(placeholder) && placeholder[0] || '',
        onFocus: this.inputFocus,
        onBlur: this.inputBlur,
        value: startValue && startValue.format(format) || ''
      }), /*#__PURE__*/React.createElement("span", {
        className: "input-separator"
      }, "~"), /*#__PURE__*/React.createElement(Input, {
        size: size,
        className: classNames('roo-input', inputClassName),
        onFocus: this.inputFocus,
        onBlur: this.inputBlur,
        disabled: disabled,
        placeholder: isArray(placeholder) && placeholder[1] || '',
        value: endValue && endValue.format(format) || ''
      }), clearable && !disabled ? /*#__PURE__*/React.createElement(IconClear, {
        onClick: this.clearTime,
        className: "addon-icon roo-date-time-picker-icon has-click"
      }) : /*#__PURE__*/React.createElement(Icon, {
        className: "addon-icon roo-date-time-picker-icon",
        name: "calendar"
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (!_Array$isArray(nextProps.value)) {
        if (_Array$isArray(state.cacheValue)) {
          // 数组到非数组，判定为由受控变为非受控，重设为当前时间。
          console.error('Warning: RangePicker 组件不应该从受控状态变为非受控状态。 More info: https://fb.me/react-controlled-components');
          return {
            startValue: '',
            endValue: '',
            startDate: dayjs(),
            endDate: dayjs().add(1, 'month'),
            hoverDate: dayjs(),
            selectDate: dayjs(),
            selectEndDate: dayjs(),
            value: nextProps.value,
            cacheValue: nextProps.value
          };
        } else {
          // 非受控状态，不处理更新
          return null;
        }
      }

      var value = nextProps.value;

      if (value !== undefined && value !== null && !_Array$isArray(value)) {
        console.warn('RangePicker: value 类型应该是数组', value);
      }

      var value0 = dateFormatter((value || [])[0], nextProps.valueOfType);
      var value1 = dateFormatter((value || [])[1], nextProps.valueOfType);
      var endDate = value1; // 没有开始或者结束时间： 不进入更新
      // FIXME: 初始值为空，在外部进行更新 value。就不会更新，产生 Bug

      if (!state.selectDate || !state.selectEndDate) {
        return null;
      } // Ranger 更新


      if (!value0 && state.startValue && !value1 && state.endValue) {
        return {
          startValue: '',
          endValue: '',
          startDate: dayjs(),
          endDate: dayjs().add(1, 'month'),
          hoverDate: dayjs(),
          selectDate: dayjs(),
          selectEndDate: dayjs()
        };
      }

      if (!value0 && state.startValue) {
        return {
          startValue: '',
          startDate: dayjs(),
          selectDate: dayjs()
        };
      }

      if (!value1 && state.endValue) {
        return {
          endValue: '',
          startValue: value0,
          startDate: value0,
          endDate: dayjs().add(1, 'month'),
          selectEndDate: dayjs()
        };
      } // 同年同月，月份加一，避免 picker 渲染相同的结果


      if (value0 && value1 && value0.year() === value1.year() && value0.month() === value1.month()) {
        endDate = value1.add(1, 'month');
      } // FIXME: 这里的比较应该是 value 和 startValue 比较，应为受控模式时： date 变了，但是 value 没有变。如果刚好 data 和 nextProps 这个相等就不会更新了。
      // value 是唯一的用来比较的值。startDate 等都是中间值
      // if ((value1 && value1.valueOf() !== state.endDate.valueOf()) || (value0 && value0.valueOf() !== state.startDate.valueOf())) {
      //     let newDate = state.endDate;
      //     if (state.endDate.year() === state.startDate.year() && state.endDate.month() === state.startDate.month()) {
      //         newDate = newDate.add(1, 'month');
      //     }
      //     return {
      //         endDate: newDate
      //     };
      // }


      if (value0 && value0.valueOf() !== state.startValue.valueOf() || value1 && value1.valueOf() !== state.endValue.valueOf()) {
        // TODO: 处理只有一个值的情况
        return {
          startValue: value0,
          endValue: value1,
          startDate: value0,
          selectDate: value0,
          hoverDate: value1,
          endDate: endDate,
          selectEndDate: value1,
          cacheValue: nextProps.value
        };
      }

      return null;
    }
  }]);

  return RangePicker;
}(React.Component);

RangePicker.defaultProps = {
  defaultValue: undefined,
  className: '',
  inputClassName: '',
  value: undefined,
  format: 'YYYY-MM-DD',
  valueOfType: 'timestamp',
  placement: 'bottomLeft',
  flip: false,
  popupContainer: document.body || document.documentElement,
  showTime: false,
  clearable: false,
  placeholder: [locale.lng('DatePicker.selectStartPlaceholder'), locale.lng('DatePicker.selectEndPlaceholder')],
  size: 'normal',
  disabled: false,
  open: false,
  disabledTime: function disabledTime() {
    return false;
  },
  disabledDate: function disabledDate() {
    return false;
  },
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onChange: function onChange() {}
};
RangePicker.propTypes = {
  defaultValue: PropTypes.array,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  valueOfType: PropTypes.string,
  value: PropTypes.array,
  format: PropTypes.string,
  showTime: PropTypes.bool,
  clearable: PropTypes.bool,
  placeholder: PropTypes.array,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  flip: PropTypes.oneOfType([PropTypes.bool]),
  placement: PropTypes.oneOf(['left', 'right', 'top', 'bottom', 'bottomLeft', 'bottomRight', 'topLeft', 'topRight']),
  popupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  disabledTime: PropTypes.func,
  disabledDate: PropTypes.func,
  open: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
};
polyfill(RangePicker);
export default RangePicker;